import { SystemIcons } from '@almbrand/systemicons';
import { useDesignSystemThemeName } from 'hooks/useDesignSystemThemeName';
import styles from './PreviewButton.module.scss';

export const PreviewButton = () => {
	const themeName = useDesignSystemThemeName();

	return (
		<button className={styles.PreviewButton__button}>
			<span className={styles.PreviewButton__icon}>
				<SystemIcons
					themeName={themeName}
					icon={'arrow_right_cta'}
					width={'100%'}
					height={'100%'}
				/>
			</span>
		</button>
	);
};
